<template>
  <div v-if="location">
    <card class="mb-4" shadow noBody>
      <template v-slot:header>
        <div class="bg-white border-0">
          <div class="row align-items-top">
            <div class="col-8">
              <h3 class="mb-0">External Links</h3>
            </div>
            <div class="col-4 text-right">
              <div v-if="!edit">
                <a href="#" @click.prevent="toggleEdit" class="text-sm">edit</a>
              </div>
              <div v-else>
                <a href="#" @click.prevent="toggleEdit" class="text-sm"
                  >cancel</a
                >
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="table-responsive">
        <!-- readonly -->
        <div v-if="!edit">
          <table class="table tablesorter">
            <tbody>
              <tr v-for="link in supportedLinks" :key="`link-${link}`">
                <td class="align-middle" width="100">{{ link }}</td>
                <td class="align-middle">
                  <div v-if="links[link]">
                    <a :href="links[link]" target="_blank">{{ links[link] }}</a>
                  </div>
                  <div v-else>
                    <em class="text-sm text-muted"> n/a </em>
                  </div>
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- edit -->
        <form v-else @submit.prevent="saveExternalLinks">
          <table class="table tablesorter">
            <tbody class="">
              <tr
                v-for="link in supportedLinks"
                :key="`supported-link-${link}`"
              >
                <td class="align-middle" width="100">{{ link }}</td>
                <td>
                  <input
                    type="input"
                    placeholder="https://"
                    class="form-control form-control-alternative fw-bold"
                    v-model="inputs[link]"
                  />
                </td>
                <td></td>
              </tr>
              <tr>
                <td>
                  <input type="submit" value="Save" class="btn btn-primary" />
                </td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </form>
      </div>
    </card>
  </div>
</template>
<script>
import copy from "copy-to-clipboard";

export default {
  mounted() {
    this.setInputs();
  },
  components: {},
  props: ["location"],
  data() {
    return {
      edit: false,
      inputs: {},
    };
  },
  computed: {
    supportedLinks() {
      return ["Trip Advisor", "Google Reviews"];
    },
    links() {
      try {
        return this.location.links || {};
      } catch (e) {
        return {};
      }
    },
  },
  methods: {
    setInputs() {
      Object.keys(this.links).forEach((link) => {
        this.inputs[link] = this.links[link] || "";
      });
    },
    toggleEdit() {
      this.setInputs();
      this.edit = !this.edit;
    },
    async saveExternalLinks() {
      const response = await this.$store.dispatch("callAPI", {
        action: "updateLocation",
        locationId: this.location.locationId,
        links: this.inputs,
      });
      this.$emit("updated", response.data.data);
      this.edit = false;
    },
    async copyUrl(url) {
      copy(url);
    },
    async openUrl(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="scss"></style>
